"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NearbySearch = void 0;
const BaseSearch_1 = require("./BaseSearch");
class NearbySearch extends BaseSearch_1.BaseSearch {
    isValid() {
        const rankby = this.get('rankby');
        if (!!rankby) {
            if (this._params.has('radius')) {
                throw new Error('`radius` and `rankby` are present.');
            }
        }
        if (this._params.has('pagetoken')) {
            console.log('pagetoken provided: params will be ignored');
        }
        return true;
    }
}
exports.NearbySearch = NearbySearch;
//# sourceMappingURL=NearbySearch.js.map